import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  urlsSection: {
    marginTop: 16
  },
  excludeUrlsTitle: {
    marginTop: 16
  },
  excludeAppsTitle: {
    marginTop: 16
  }
})

export default useStyles
